(function () {
    'use strict';

    angular
        .module('cabinPerformanceComment')
        .factory('CabinPerformanceCommentFactory', CabinPerformanceCommentFactory);

    function CabinPerformanceCommentFactory() {

        function SearchCriteriaDTO() {
    		this.fromDate = null;
    		this.toDate = null;
    		this.crewId = null;
        }

        function UpdateRequest() {
          this.cabinFlightRatingId = null;
          this.ratedBy = null;
          this.ratingComment = null;
          this.rating = null;
          this.ratedUserId = null;
        }

        function EditorData() {
          this.checkIn = null;
          this.checkInDateTime = null;
          this.blockTime = null;
          this.rating = null;
          this.criteriaDescription = null;
          this.ratingComments = null;
          this.ratedBy = null;
          this.cabinFlightRatingId = null;
          this.cabinFlightRatingLogDTOList = [];

        }

        function GetCabinPerformanceReportSearchRequest() {
          return new SearchCriteriaDTO();
        }

        function GetCabinPerformanceReportUpdateRequest() {
          return new UpdateRequest();
        }

        function GetCabinPerformanceReportEditorData() {
          return new EditorData();
        }

        return {
          getCabinPerformanceReportSearchRequest: GetCabinPerformanceReportSearchRequest,
          getCabinPerformanceReportUpdateRequest: GetCabinPerformanceReportUpdateRequest,
          getCabinPerformanceReportEditorData : GetCabinPerformanceReportEditorData
        }
    }
})();
